import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row mb-3 col-md-12" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-8" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-dialog-title" }, " Comments ")
], -1)
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "col-md-12 d-flex justify-content-end" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "row col-md-12 mb-5" }
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = { class: "text-danger" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "w-100" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { style: {"border-bottom":"2px solid #000000"} }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"7%","border-right":"2px solid #000000"} }),
    /*#__PURE__*/_createElementVNode("th", null, "Comments"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, "Last Modified By"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"18%"} }, "Time")
  ])
], -1)
const _hoisted_14 = { style: {"border-right":"2px solid #000000"} }
const _hoisted_15 = {
  key: 1,
  style: {"height":"300px"},
  class: "d-flex align-items-center"
}
const _hoisted_16 = { class: "error-no-record" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)
const _hoisted_18 = {
  key: 2,
  style: {"height":"300px"},
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_19 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheTabViewLoading = _resolveComponent("TheTabViewLoading")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-dialog-maximized sheet-comments-dialog",
    visible: _ctx.isVisible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isVisible) = $event)),
    closable: false,
    draggable: false
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (!_ctx.isLoading && _ctx.companyReportSheets.length > 0)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    label: "Export",
                    icon: "pi pi-external-link",
                    onClick: _ctx.exportSheetsComments
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                class: "p-dialog-header-icons",
                icon: "pi pi-times",
                severity: "secondary",
                text: "",
                rounded: "",
                onClick: _ctx.closeDialog
              }, null, 8, ["onClick"])
            ])
          ])
        ])
      ])
    ]),
    default: _withCtx(() => [
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.pageError == '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyReportSheets, (companyReportSheet, companyReportSheetIndex) => {
                    return (_openBlock(), _createElementBlock("div", { key: companyReportSheetIndex }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("h6", null, [
                            _createElementVNode("span", null, _toDisplayString(companyReportSheet.title.sheet), 1),
                            _createElementVNode("span", _hoisted_10, " ID: " + _toDisplayString(companyReportSheet.title.id), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("table", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyReportSheet.sheetComments, (sheetComment, sheetCommentIndex) => {
                                return (_openBlock(), _createElementBlock("tr", { key: sheetCommentIndex }, [
                                  _createElementVNode("th", _hoisted_14, _toDisplayString(sheetComment.cell), 1),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.getCommentValue(sheetComment.comment)), 1),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.getCommentUsername(sheetComment.comment)), 1),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.getCommentTime(sheetComment.comment)), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.pageError == '' && _ctx.companyReportSheets.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_FontAwesomeIcon, {
                      icon: ['fas', 'image'],
                      size: "2x"
                    }),
                    _hoisted_17
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.pageError != '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_ThePageError, {
                    onBackEvent: _ctx.closeDialog,
                    pageError: _ctx.pageError
                  }, null, 8, ["onBackEvent", "pageError"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createVNode(_component_TheTabViewLoading)
          ]))
    ]),
    _: 1
  }, 8, ["visible"]))
}